{
  "SET_NEW_PASSWORD": {
    "TITLE": "Nieuw wachtwoord instellen",
    "PASSWORD": {
      "LABEL": "Wachtwoord",
      "PLACEHOLDER": "Wachtwoord",
      "ERROR": "Wachtwoord is te kort."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bevestig wachtwoord",
      "PLACEHOLDER": "Bevestig wachtwoord",
      "ERROR": "Wachtwoorden komen niet overeen."
    },
    "API": {
      "SUCCESS_MESSAGE": "Wachtwoord succesvol veranderd.",
      "ERROR_MESSAGE": "Kan geen verbinding maken met de Woot server. Probeer het opnieuw."
    },
    "CAPTCHA": {
      "ERROR": "Verificatie verlopen. Los de captcha opnieuw op."
    },
    "SUBMIT": "Bevestigen"
  }
}
